import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MiscService, VisitorAppointmentService } from '@services/index';

declare var swal: any;

@Component({
    selector: 'app-util-visitor-parts-appointment-list',
    templateUrl: './list.component.html',
})
export class UtilVisitorPartsAppointmentListComponent implements OnInit {
    @Input() visitor: any = null;
    @Output() updateEvent = new EventEmitter();

    isLoading = true;
    isLoadingVisitors = false;
    selfVisitor = false;
    filter: any = {
        date_begin: null,
        date_end: null
    };
    limit = 20;
    page = 1;
    visitorAppointments: any;
    hasData = {
        visitorAppointments: false
    };

    constructor(private cdref: ChangeDetectorRef,
                private miscService: MiscService,
                private visitorAppointmentService: VisitorAppointmentService) {}

    ngOnInit() {
        if(this.miscService.checkEnvPermission("getVisitorAppointment")) {
            this.isLoading = true;
            this.selfVisitor = this.miscService.checkDataLength(this.visitor) ? true : false;
            this.getVisitorsAppointments();
        }
        this.cdref.detectChanges();
    }

    filterVisitorAppointments(filter = null) {
        this.filter = filter;
        this.getVisitorsAppointments(true);
    }

    getVisitorsAppointments(hasFilter = false) {
        this.isLoading = true;
        let data = this.filter;
        data.visitor_ids = this.selfVisitor ? [this.visitor.id] : (data.visitor_ids && data.visitor_ids.length ? data.visitor_ids : null);
        data.limit = this.limit;
        data.page = !hasFilter ? this.page : 1;     // if user has filtered, then reset page to 1 (number of pages can change due to filters)
        this.visitorAppointmentService.getByVisitors(data).subscribe(data => {
            this.visitorAppointments = data;
            this.hasData.visitorAppointments = this.miscService.checkDataLength(this.visitorAppointments.data);
            this.isLoading = false;
        }, error => {
            this.visitorAppointments = null;
            this.hasData.visitorAppointments = false;
            this.miscService.showMsg({ msg: "VISITOR_APPOINTMENTS_NOT_FOUND_PLEASE_CHECK_FILTERS" });
            this.isLoading = false;
        });
    }
    
    addAppointment() {
        this.getVisitorsAppointments();
        this.updateEvent.emit();
    }

    switchPage(page) {
        this.page = page;
        this.getVisitorsAppointments();
    }

    delete(visitorAppointment) {
        let self = this;
        let title = this.miscService._t('VISITORS_APPOINTMENTS.DELETE_APPOINTMENT') + " ?";
        swal({
            title: title,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this.miscService._t('SHARED.CONFIRM'),
            cancelButtonText: this.miscService._t('SHARED.CANCEL'),
            closeOnConfirm: true,
            closeOnCancel: true,
        }, function(isConfirm) {
            if(isConfirm) {
                self.visitorAppointmentService.delete(visitorAppointment.id).subscribe(data => {
                    self.getVisitorsAppointments(true);  // resets page to 1 (in case of there is only 1 visitor appointment on the current page)
                    self.miscService.showMsg({ msg: "VISITOR_APPOINTMENT_DELETED", status: "success" });
                    self.updateEvent.emit();
                }, error => {
                    self.miscService.showMsg({ msg: "VISITOR_APPOINTMENT_NOT_DELETED" });
                });
            }
        });
    }
}
